import styles from './BookedState.module.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface InterviewLineProps {
  roleName: string | null;
  companyName: string | null;
}

/** Which role this interview is for and with whom, from whatever the API knows of either. */
const InterviewLine: FC<InterviewLineProps> = ({ roleName, companyName }) => {
  const { t } = useTranslation();

  if (roleName && companyName) {
    return (
      <p className={styles.subline}>
        {t('publicScheduling.bookedWithCompany', {
          role: roleName,
          company: companyName,
        })}
      </p>
    );
  }
  if (companyName) {
    return (
      <p className={styles.subline}>
        {t('publicScheduling.bookedCompanyOnly', { company: companyName })}
      </p>
    );
  }
  if (roleName) {
    return (
      <p className={styles.subline}>
        {t('publicScheduling.roleInterviewTitle', { role: roleName })}
      </p>
    );
  }

  return null;
};

export default InterviewLine;
